import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { mockUsers } from '../../data/mockData';
import { useAuth } from '../../contexts/AuthContext';
interface UserListProps {
  onAddUser: () => void;
}
export function UserList({
  onAddUser
}: UserListProps) {
  const {
    isMaker,
    isAdmin
  } = useAuth();
  const getRoleBadgeColor = (role: string) => {
    if (role.includes('Admin')) return 'bg-purple-100 text-purple-800';
    return 'bg-blue-100 text-blue-800';
  };
  return <div className="space-y-6" data-id="element-670">
      <div className="flex items-center justify-between" data-id="element-671">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-672">User Management</h2>
        {isAdmin && isMaker && <Button onClick={onAddUser} leftIcon={<Plus className="w-4 h-4" data-id="element-674" />} data-id="element-673">
            Add New User
          </Button>}
      </div>

      <DataTable columns={[{
      header: 'Full Name',
      accessor: 'fullName'
    }, {
      header: 'Email',
      accessor: 'email'
    }, {
      header: 'Role',
      accessor: u => <span className={`px-2 py-1 rounded-full text-xs font-medium ${getRoleBadgeColor(u.role)}`} data-id="element-676">
                {u.role}
              </span>
    }, {
      header: 'Branch ID',
      accessor: 'branchId'
    }, {
      header: 'Status',
      accessor: u => <StatusBadge status={u.status} size="sm" data-id="element-677" />
    }, {
      header: 'Actions',
      accessor: () => <Button variant="ghost" size="sm" className="text-[#1B6B3A]" data-id="element-678">
                Edit
              </Button>
    }]} data={mockUsers} data-id="element-675" />
    </div>;
}